import React, { Dispatch, SetStateAction } from 'react';
import { NavBarMenuButton } from '../../components/controls/navbar';

export interface ApplicationMenuButtonProps {
   setMenuVisible: Dispatch<SetStateAction<boolean>>;
}

export const ApplicationMenuButton = (props: ApplicationMenuButtonProps) => {
   const { setMenuVisible } = props;

   return (
      <NavBarMenuButton
         onClick={() => {
            setMenuVisible(true);
         }}
      />
   );
};
